module.exports = __webpack_public_path__ + "media/images/e-bilet/Train-photoshop-cb866ff1603f82cb8f1e18c46969a5ad.png";